import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [{ path: '', redirectTo: '/login', pathMatch: 'full' }];

// no layout routes
//  { path: 'login', component: LoginComponent},
//  { path: 'register', component: RegisterComponent },
// otherwise redirect to home
// */

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
